import axios from "axios";
import __errorHandler from "./errorHandler";
import __poppyHandler from "./poppyHandler";

let approveApplicationElm = document.getElementById('approve_application');
let rejectApplicationElm = document.getElementById('reject_application');

if (approveApplicationElm) {

    approveApplicationElm.onclick = function() {

        approveApplicationElm.classList.add('button--disabled');
        approveApplicationElm.setAttribute('disabled', 'disabled');
        rejectApplicationElm.classList.add('button--disabled');
        rejectApplicationElm.setAttribute('disabled', 'disabled');

        let form = approveApplicationElm.closest('form');
        axios.put(form.getAttribute('action'), {
            _token: form.querySelector('input[name="_token"]').value,
            status: 'waiting_payment',
            quick_update: true,
        }).then(function(response) {
            let data = response.data;
            if (data.redirect) {
                location = data.redirect;
            } else {
                __poppyHandler.info("Onaylanacak başka başvuru kalmadı");
                document.querySelector('.actions').style.display = 'none';
            }
        }).catch(function(response) {
            __errorHandler.handle(response);
        }).then(function() {
            approveApplicationElm.classList.remove('button--disabled');
            approveApplicationElm.removeAttribute('disabled');
            rejectApplicationElm.classList.remove('button--disabled');
            rejectApplicationElm.removeAttribute('disabled');
        });

        return false;
    }

}

if (rejectApplicationElm) {

    rejectApplicationElm.onclick = function() {

        approveApplicationElm.classList.add('button--disabled');
        approveApplicationElm.setAttribute('disabled', 'disabled');
        rejectApplicationElm.classList.add('button--disabled');
        rejectApplicationElm.setAttribute('disabled', 'disabled');

        let form = approveApplicationElm.closest('form');
        axios.put(form.getAttribute('action'), {
            _token: form.querySelector('input[name="_token"]').value,
            status: 'rejected',
            quick_update: true,
        }).then(function(response) {
            let data = response.data;
            if (data.redirect) {
                location = data.redirect;
            } else {
                __poppyHandler.info("Onaylanacak başka başvuru kalmadı");
                document.querySelector('.actions').style.display = 'none';
            }
        }).catch(function(response) {
            __errorHandler.handle(response);
        }).then(function() {
            approveApplicationElm.classList.remove('button--disabled');
            approveApplicationElm.removeAttribute('disabled');
            rejectApplicationElm.classList.remove('button--disabled');
            rejectApplicationElm.removeAttribute('disabled');
        });

        return false;
    }

}
